<template>
    <el-container style="height: calc(100vh - 52px)">
        <el-header style="height: auto;" class="bg-gray-200 p-3 md:p-5">
            <div class="flex w-full flex-col md:flex-row">
                <!-- 検索部 -->
                <div class="hidden md:block bg-white border-2 border-gray-400 rounded-md p-4">
                    <el-form :model="searchForm" label-width="auto" label-position="top">
                        <div class="grid gap-4" :class="[
                                loginUserRole === ROLES.SYSTEM ? 'md:grid-cols-6' : (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead ? 'md:grid-cols-5' : 'md:grid-cols-4'),
                            ]">
                            <el-form-item class="no-margin" v-show="loginUserRole === ROLES.SYSTEM" label="組織">
                                <OrganizationSelect v-model="searchForm.organization_id" :is-search="true"
                                    placeholder="組織を選択" />
                            </el-form-item>

                            <el-form-item class="no-margin"
                                v-show="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)" label="部門">
                                <DepartmentSelect :organization-id="searchForm.organization_id" :is-search="true"
                                    v-model="searchForm.department_id" placeholder="部門を選択" @organization-id-change="searchForm.organization_id = $event" />
                            </el-form-item>

                            <el-form-item class="no-margin" label="カテゴリ">
                                <CategorySelect :organization-id="searchForm.organization_id" :is-search="true"
                                    v-model="searchForm.category_id" placeholder="カテゴリを選択" />
                            </el-form-item>

                            <el-form-item class="no-margin" label="アイテム名">
                                <AutoCompleteInput v-model="searchForm.material_name" placeholder="アイテム名を入力"
                                    storage-key="material-name-history" :max-history-items="15"
                                    ref="materialNameInput" />
                            </el-form-item>

                            <el-form-item class="no-margin" label="アラート">
                                <el-select v-model="searchForm.time_filter" placeholder="アラートを選択" style="width: 100%">
                                    <el-option label="すべて" value="すべて" />
                                    <el-option label="1日前" value="1日前" />
                                    <el-option label="3日前" value="3日前" />
                                    <el-option label="7日前" value="7日前" />
                                </el-select>
                            </el-form-item>

                            <div class="flex justify-end mt-7">
                                <el-button class="hidden md:block w-24" type="info"
                                    @click="handleSearchButton">検索</el-button>
                            </div>

                        </div>
                    </el-form>
                </div>

                <el-drawer class="md:hidden bg-gray-200" v-model="drawer" title="検索" direction="ttb"
                    :with-header="false" size="auto">
                    <div class="bg-white border-2 border-gray-400 rounded-md p-4">
                        <el-form :model="searchForm" label-width="auto" label-position="top">
                            <div class="grid gap-4">
                                <el-form-item class="no-margin" v-show="loginUserRole === ROLES.SYSTEM" label="組織">
                                    <OrganizationSelect v-model="searchForm.organization_id" :is-search="true"
                                        placeholder="組織を選択" />
                                </el-form-item>

                                <el-form-item class="no-margin"
                                    v-show="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)" label="部門">
                                    <DepartmentSelect :organization-id="searchForm.organization_id" :is-search="true"
                                        v-model="searchForm.department_id" placeholder="部門を選択" @organization-id-change="searchForm.organization_id = $event" />
                                </el-form-item>

                                <el-form-item class="no-margin" label="カテゴリ">
                                    <CategorySelect :organization-id="searchForm.organization_id" :is-search="true"
                                        v-model="searchForm.category_id" placeholder="カテゴリを選択" />
                                </el-form-item>

                                <el-form-item class="no-margin" label="アラート">
                                    <el-select v-model="searchForm.time_filter" placeholder="アラートを選択" style="width: 100%">
                                        <el-option label="すべて" value="すべて" />
                                        <el-option label="1日前" value="1日前" />
                                        <el-option label="3日前" value="3日前" />
                                        <el-option label="7日前" value="7日前" />
                                    </el-select>
                                </el-form-item>

                                <div class="flex">
                                    <el-form-item class="no-margin flex-grow" label="アイテム名">
                                        <AutoCompleteInput v-model="searchForm.material_name" placeholder="アイテム名を入力"
                                        storage-key="material-name-history" :max-history-items="15"
                                        ref="materialNameInput" />
                                    </el-form-item>

                                    <div class="flex justify-end mt-7">
                                        <el-button class="md:hidden ml-3" type="info" @click="handleSearchButton" circle>
                                            <el-icon>
                                                <span class="material-symbols-outlined">manage_search</span>
                                            </el-icon>
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </el-drawer>

                <!-- 操作部 -->
                <div class="flex justify-end items-center md:flex-grow">
                    <el-button class="custom-icon-btn md:hidden" type="info" @click="drawer = true" circle>
                        <span class="material-symbols-outlined">
                            manage_search
                        </span>
                    </el-button>

                    <el-button class="custom-icon-btn" type="info" 
                        @click="handleExportButton" circle>
                        <span class="material-symbols-outlined">
                            download_2
                        </span>
                    </el-button>
                </div>
            </div>
        </el-header>

        <el-mian style="padding-bottom: 20px;">
            <!-- 手机CARD部 -->
            <div class="md:hidden" v-loading="loading" style="height: calc(100vh - 177px)">
                <div class="custom-title flex flex-col">
                    <span>定数管理（過不足　品名　在庫数　定数）</span>
                    <div class="ml-auto">                        
                        <div class="flex items-center space-x-1">
                            <span class="text-white">ソート:</span>
                            <el-button 
                                size="small" 
                                @click="handleSort('material_name')"
                                :class="['mobile-sort-btn', sortField === 'material_name' ? 'active' : '']">
                                アイテム名
                            </el-button>
                            <el-button 
                                v-if="loginUserRole === ROLES.SYSTEM"
                                size="small" 
                                @click="handleSort('organization_name')"
                                :class="['mobile-sort-btn', sortField === 'organization_name' ? 'active' : '']">
                                組織
                            </el-button>
                            <el-button 
                                v-if="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)"
                                size="small" 
                                @click="handleSort('department_name')"
                                :class="['mobile-sort-btn', sortField === 'department_name' ? 'active' : '']">
                                部門
                            </el-button>
                            <el-button 
                                size="small" 
                                @click="handleSort('difference')"
                                :class="['mobile-sort-btn', sortField === 'difference' ? 'active' : '']">
                                過不足    
                            </el-button>
                            <span class="text-white">アイテム数: {{ mTotalRecords }}</span>
                        </div>
                    </div>
                </div>

                <div style="overflow-y: auto; height: calc(100vh - 227px)">
                    <el-card v-for="item in mTableData" :key="item.id"
                        style="border: 1px solid #d1d5db; border-radius: 0px">
                        <div class="relative">
                            <el-checkbox class="absolute top-[-6px] right-1" :model-value="selectedItems.some(t => t.inventory_id === item.inventory_id)" size="large" @change="handleCheckboxChange(item)" />
                            <el-row align="middle" class="relative z-0">
                                <el-col :span="8" align="middle">
                                    <span class="text-5xl">
                                        {{ item.quantity - item.constantQuantity }}
                                    </span>
                                </el-col>

                                <el-col :span="15" class="ml-2">
                                    <div class="flex flex-col justify-between">
                                        <div v-if="loginUserRole === ROLES.SYSTEM">{{ item.organization_name }}</div>
                                        <div v-if="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)">{{ item.department_name }}</div>
                                    </div>
                                    <div class="flex flex-col justify-between">
                                        <div>{{ item.material_name }}</div>
                                        <div v-if="item.category_name" class="text-sm text-gray-500">{{ item.category_name }}</div>
                                    </div>
                                    <el-row align="middle">
                                        <el-col :span="12">
                                            <span>
                                                在庫数：{{ item.quantity }}
                                            </span>
                                        </el-col>

                                        <el-col :span="12">
                                            <span>
                                                定数：{{ item.constantQuantity }}
                                            </span>
                                        </el-col>
                                    </el-row>
                                    <el-row align="middle" v-if="item.last_export_date">
                                        <el-col :span="24">
                                            <span class="text-sm text-gray-500">
                                                最終出力日時：{{ moment(item.last_export_date).format('YYYY-MM-DD HH:mm') }}
                                            </span>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </div>
                    </el-card>
                </div>
            </div>

            <!-- WEB表格部 -->
            <div class="hidden md:block w-full">
                <el-table :data="mTableData" height="calc(100vh - 260px)" v-loading="loading">
                    <el-table-column width="55" align="center">
                        <template #default="scope">
                            <el-checkbox :model-value="selectedItems.some(t => t.inventory_id === scope.row.inventory_id)" size="large" @change="handleCheckboxChange(scope.row)" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="organization_name" label="組織" width="200">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('organization_name')">
                                <span>{{ getSortLabel('organization_name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'organization_name' }">
                                        {{ getSortIcon('organization_name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="department_name" label="部門" width="160">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('department_name')">
                                <span>{{ getSortLabel('department_name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'department_name' }">
                                        {{ getSortIcon('department_name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="category_name" label="カテゴリ" width="160">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('category_name')">
                                <span>{{ getSortLabel('category_name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'category_name' }">
                                        {{ getSortIcon('category_name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="material_name" label="アイテム名" min-width="400">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('material_name')">
                                <span>{{ getSortLabel('material_name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'material_name' }">
                                        {{ getSortIcon('material_name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                        <template #default="scope">
                            {{ scope.row.material_name }}<br />
                            <span v-if="scope.row.jancode" class="text-sm text-gray-500">
                                （{{ scope.row.jancode }}）
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="quantity" label="在庫数" width="80" header-align="center" align="right">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('quantity')">
                                <span>{{ getSortLabel('quantity') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'quantity' }">
                                        {{ getSortIcon('quantity') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="constantQuantity" label="定数" width="80" header-align="center" align="right">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('constantQuantity')">
                                <span>{{ getSortLabel('constantQuantity') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'constantQuantity' }">
                                        {{ getSortIcon('constantQuantity') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="過不足" width="80" header-align="center" align="right">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('difference')">
                                <span>{{ getSortLabel('difference') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'difference' }">
                                        {{ getSortIcon('difference') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                        <template #default="scope">
                            {{ scope.row.quantity - scope.row.constantQuantity }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="last_export_date" label="最終出力日時" width="160">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('last_export_date')">
                                <span>{{ getSortLabel('last_export_date') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'last_export_date' }">
                                        {{ getSortIcon('last_export_date') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                        <template #default="scope">
                            {{ scope.row.last_export_date ? moment(scope.row.last_export_date).format('YYYY-MM-DD HH:mm:ss') : '-' }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页部 -->
            <div class="flex w-full justify-end mt-4">
                <div class="hidden md:block mr-3">
                    <el-pagination v-model:current-page="mCurrentPage" v-model:page-size="mPageSize"
                        :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
                        :total="mTotalRecords" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </div>

                <div class="md:hidden">
                    <el-pagination layout="prev, pager, next" :total="mTotalRecords"
                        @current-change="handleCurrentChange" />
                </div>
            </div>
        </el-mian>
    </el-container>
</template>

<script lang="ts">
import { ElMessage, ElMessageBox, ElPagination, ElTable, ElTableColumn } from 'element-plus';
import { defineComponent, onMounted, ref } from 'vue';
import OrganizationSelect from '@/components/common/OrganizationSelect.vue';
import CategorySelect from '@/components/common/CategorySelect.vue';
import UserSelect from '@/components/common/UserSelect.vue';
import DepartmentSelect from '@/components/common/DepartmentSelect.vue';
import MaterialSelect from '@/components/common/MaterialSelect.vue';
import AutoCompleteInput from '@/components/common/AutoCompleteInput.vue';
import axios, { AxiosResponse } from 'axios';
import { Bell, Delete, Search, Promotion, ZoomIn, Plus } from '@element-plus/icons-vue';
import { ErrorCode, ResponseData, ResponseStatus } from '@/components/common/response';
import { getErrorMessage, PageType } from '@/components/common/errorMessage';
import { SearchRequest } from '@/components/common/request';
import router from '@/router';
import { ALL, ROLES, ROUTES } from '@/config/constants';
import moment from 'moment';

interface checkResultInfo {
    id: string,
    organization_id: string,
    organization_name: string,
    department_id: string,
    department_name: string,
    material_code: string,
    material_name: string,
    category_id: string,
    category_name: string,
    inventory_id: string,
    sk: string,
    quantity: number,
    constantQuantity: number,
    last_export_date?: string,  // 最后输出时间
}

export default defineComponent({
    name: 'MngConstantManage2',
    components: {
        ElTable,
        ElTableColumn,
        ElPagination,
        OrganizationSelect,
        CategorySelect,
        DepartmentSelect,
        UserSelect,
        MaterialSelect,
        AutoCompleteInput,
        Bell,
        Plus,
        ZoomIn,
        Delete,
        Search,
        Promotion,
    },
    setup() {
        const searchForm = ref<any>({
            organization_id: ALL,
            department_id: ALL,
            category_id: ALL,
            material_name: '',
            time_filter: 'すべて', // 时间过滤选项
        });

        const drawer = ref(false);

        const loading = ref<boolean>(true);
        
        // 表格相关状态
        const mTableData = ref<checkResultInfo[]>([]);          // 排序完成，显示在表格里的数据（单页的数据）
        const mAllData = ref<checkResultInfo[]>([]);            // 存储所有查询结果（最大1000件）
        
        // 分页相关状态
        const mCurrentPage = ref<number>(1);
        const mPageSize = ref<number>(10);
        const mTotalRecords = ref<number>(0);
        const hasMoreData = ref<boolean>(false); // 添加hasMoreData状态

        // 排序相关状态
        const sortField = ref<string>('material_name'); // 当前排序字段
        const sortOrder = ref<'asc' | 'desc'>('asc'); // 当前排序方向

        // 排序配置 - 方便添加新的排序字段
        const sortConfig = {
            'material_name': {
                label: 'アイテム名',
                mobileLabel: 'アイテム名',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            'quantity': {
                label: '在庫数',
                mobileLabel: '在庫数',
                type: 'number' as const,
                defaultOrder: 'desc' as const
            },
            'constantQuantity': {
                label: '定数',
                mobileLabel: '定数',
                type: 'number' as const,
                defaultOrder: 'desc' as const
            },
            'difference': {
                label: '過不足',
                mobileLabel: '過不足',
                type: 'number' as const,
                defaultOrder: 'desc' as const
            },
            'organization_name': {
                label: '組織',
                mobileLabel: '組織',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            'department_name': {
                label: '部門',
                mobileLabel: '部門',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            'category_name': {
                label: 'カテゴリ',
                mobileLabel: 'カテゴリ',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            'last_export_date': {
                label: '最終出力日時',
                mobileLabel: '最終出力日時',
                type: 'date' as const,
                defaultOrder: 'desc' as const
            }
        };

        const size = ref<string>('small');

        const loginUserRole = localStorage.getItem('role');
        const loginUserRoleIsHead = localStorage.getItem('is_head') === '1';

        const materialNameInput = ref<any>(null);

        const selectedItems = ref<checkResultInfo[]>([]);

        /***** マウント **************************/
        onMounted(() => {
            //  如果没有信息，重新登陆
            if (!loginUserRole) {
                router.push(`/${ROUTES.LOGIN}`);
            }
            getCheckResultList();
        });

        /***** ボタン **************************/
        const handleSearchButton = () => {
            drawer.value = false;

            if (materialNameInput.value) {
                materialNameInput.value.submitValue();
            }
            mCurrentPage.value = 1; // 重置到第一页
            getCheckResultList();
        };

        const handleSizeChange = (size: number) => {
            mPageSize.value = size;
            calculatePagination();
        };
        
        const handleCurrentChange = (page: number) => {
            mCurrentPage.value = page;
            calculatePagination();
        };

        // 处理排序
        const handleSort = (field: string) => {
            if (sortField.value === field) {
                // 如果点击的是当前排序字段，切换排序方向
                sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
            } else {
                // 如果点击的是新字段，使用该字段的默认排序方向
                sortField.value = field;
                sortOrder.value = sortConfig[field as keyof typeof sortConfig]?.defaultOrder || 'asc';
            }
            calculatePagination();
        };

        // 获取排序图标
        const getSortIcon = (field: string) => {
            if (sortField.value !== field) {
                return 'unfold_more'; // 未排序状态
            }
            return sortOrder.value === 'asc' ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
        };

        // 获取排序字段的标签
        const getSortLabel = (field: string, isMobile: boolean = false) => {
            const config = sortConfig[field as keyof typeof sortConfig];
            return config ? (isMobile ? config.mobileLabel : config.label) : field;
        };

        // 比较函数工厂
        const createComparator = (field: string, order: 'asc' | 'desc') => {
            const config = sortConfig[field as keyof typeof sortConfig];
            const fieldType = config?.type || 'string';
            
            return (a: checkResultInfo, b: checkResultInfo) => {
                let aValue: any = a[field as keyof checkResultInfo];
                let bValue: any = b[field as keyof checkResultInfo];
                
                // 特殊处理 difference 字段（過不足）
                if (field === 'difference') {
                    aValue = a.quantity - a.constantQuantity;
                    bValue = b.quantity - b.constantQuantity;
                }
                
                // 根据字段类型进行特殊处理
                switch (fieldType) {
                    case 'number':
                        aValue = Number(aValue) || 0;
                        bValue = Number(bValue) || 0;
                        break;
                    case 'date':
                        // 处理日期类型，将字符串转换为Date对象进行比较
                        aValue = aValue ? new Date(aValue).getTime() : 0;
                        bValue = bValue ? new Date(bValue).getTime() : 0;
                        break;
                    case 'string':
                        if (typeof aValue === 'string' && typeof bValue === 'string') {
                            aValue = aValue.toLowerCase();
                            bValue = bValue.toLowerCase();
                        }
                        break;
                }
                
                // 处理空值
                if (aValue === null || aValue === undefined) aValue = '';
                if (bValue === null || bValue === undefined) bValue = '';
                
                let comparison = 0;
                if (aValue < bValue) comparison = -1;
                if (aValue > bValue) comparison = 1;
                
                // 根据排序方向返回结果
                return order === 'asc' ? comparison : -comparison;
            };
        };

        // 前端分页计算（支持多项目排序）
        const calculatePagination = () => {
            // 使用比较函数工厂创建排序函数
            const comparator = createComparator(sortField.value, sortOrder.value);
            
            // 对数据进行排序
            const sortedData = [...mAllData.value].sort(comparator);
            
            // 计算分页
            const startIndex = (mCurrentPage.value - 1) * mPageSize.value;
            const endIndex = startIndex + mPageSize.value;
            
            mTableData.value = sortedData.slice(startIndex, endIndex);
            mTotalRecords.value = mAllData.value.length;
        };

        /***** DB 操作 **************************/
        const getCheckResultList = async () => {
            loading.value = true;
            try {
                const params: SearchRequest = {
                    organization_id: searchForm.value.organization_id === ALL ? '' : searchForm.value.organization_id,
                    department_id: searchForm.value.department_id === ALL ? '' : searchForm.value.department_id,
                    category_id: searchForm.value.category_id === ALL ? '' : searchForm.value.category_id,
                    material_name: searchForm.value.material_name,
                    time_filter: searchForm.value.time_filter,
                    check_result: 6, // 在庫数チェック
                };

                const res: AxiosResponse<ResponseData<checkResultInfo[]>> = await axios.get('/api/constant-settings/search', { params });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    console.log(res.data);
                    const { data, total, hasMoreData: moreData } = res.data;
                    
                    mAllData.value = data || [];
                    hasMoreData.value = moreData || false; // 设置hasMoreData状态

                    // 计算分页
                    calculatePagination();

                    // 如果有更多数据，显示提示信息
                    if (hasMoreData.value) {
                        ElMessage({
                            message: '検索結果が1000件を超えています。より詳細な検索条件を設定してください。',
                            type: 'warning',
                            duration: 5000,
                            showClose: true
                        });
                    }
                } else {
                    ElMessage.error(getErrorMessage(PageType.ALERT, res.data.code));
                }

            } catch (error) {
                ElMessage.error(getErrorMessage(PageType.ALERT));
            } finally {
                loading.value = false;
            }
        };

        const handleExportButton = () => {
            if (selectedItems.value.length === 0) {
                ElMessage.warning('選択された項目がありません');
                return;
            }

            ElMessageBox.confirm('選択した項目をCSV形式で出力しますか？', 'CSVエクスポート', {
                confirmButtonText: 'エクスポート',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                exportConstantManage();
            }).catch(() => {
                // console.log('削除キャンセル');
            });
        };

        const exportConstantManage = async () => {
            try {
                // 获取选中的inventory_ids
                const inventoryIds = selectedItems.value.map(item => item.inventory_id);
                
                // 调用后端API导出CSV
                const response = await axios.post('/api/constant-settings/export-csv', {
                    inventory_ids: inventoryIds
                }, {
                    responseType: 'blob' // 设置响应类型为blob
                });

                // 检查响应状态
                if (response.status !== 200) {
                    throw new Error('Export failed');
                }

                // 创建下载链接
                const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                
                // 从响应头获取文件名，如果没有则使用默认文件名
                const contentDisposition = response.headers['content-disposition'];
                let filename = '定数管理_' + moment(new Date().toISOString()).format('YYYYMMDDHHmmss') + '.csv';
                if (contentDisposition) {
                    // 优先尝试获取UTF-8编码的文件名
                    const utf8FilenameMatch = contentDisposition.match(/filename\*=UTF-8''(.+)/);
                    if (utf8FilenameMatch) {
                        filename = decodeURIComponent(utf8FilenameMatch[1]);
                    } else {
                        // 如果没有UTF-8编码的文件名，尝试获取标准文件名
                        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                        if (filenameMatch) {
                            filename = decodeURIComponent(filenameMatch[1]);
                        }
                    }
                }
                
                link.download = filename;
                link.click();
                
                ElMessage.success('CSVエクスポートが完了しました。');
            }
            catch (error: any) {
                console.error('CSV export error:', error);
                
                // 如果是blob响应，尝试读取错误信息
                if (error.response && error.response.data instanceof Blob) {
                    const reader = new FileReader();
                    reader.onload = () => {
                        const errorMessage = reader.result as string;
                        ElMessage.error(errorMessage || 'CSVエクスポート失敗しました。');
                    };
                    reader.readAsText(error.response.data);
                } else {
                    ElMessage.error('CSVエクスポート失敗しました。');
                }
            } finally {
                selectedItems.value = []; // 清空已选择的项
            }
        };

        const handleCheckboxChange = (item: checkResultInfo) => {
            if (!selectedItems.value.some(t => t.inventory_id === item.inventory_id)) {
                selectedItems.value.push(item);
            } else {
                selectedItems.value = selectedItems.value.filter(selectedItem => selectedItem.inventory_id !== item.inventory_id);
            }

            console.log(selectedItems.value);
        };

        return {
            loginUserRole,
            loginUserRoleIsHead,
            searchForm,
            mTableData,
            loading,
            mCurrentPage,
            mPageSize,
            mTotalRecords,
            size,
            handleSearchButton,
            handleSizeChange,
            handleCurrentChange,
            ROLES,
            ALL,
            materialNameInput,
            handleExportButton,
            handleCheckboxChange,
            drawer,
            selectedItems,
            hasMoreData,
            sortField,
            sortOrder,
            handleSort,
            getSortIcon,
            getSortLabel,
            moment,
        }
    }
});
</script>

<style scoped>
.sort-header {
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s;
    white-space: nowrap;
    display: flex;
    align-items: center;
}

.sort-header:hover {
    background-color: #f5f7fa;
}

/* 确保表头内容不换行 */
:deep(.el-table .el-table__header-wrapper .el-table__header th) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 手机端排序按钮样式 */
.mobile-sort-btn {
    padding: 1px 4px;
    font-size: 11px;
    border-radius: 3px;
    transition: all 0.2s;
    white-space: nowrap;
    min-width: auto;
    height: 20px;
    line-height: 1;
    background-color: white;
    border: 1px solid #d1d5db;
}

.mobile-sort-btn:hover {
    background-color: #f8f9fa;
    color: #409eff;
    border-color: #409eff;
}

.mobile-sort-btn.active {
    background-color: #e6f7ff;
    color: #409eff;
    border-color: #409eff;
}
</style>